var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeclineIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.585074 0.610594C0.959811 0.235635 1.46799 0.0250145 1.99785 0.0250145C2.52772 0.0250145 3.0359 0.235635 3.41063 0.610594L13.9874 11.1966L24.5643 0.610594C24.7487 0.419555 24.9691 0.267195 25.2129 0.162375C25.4567 0.057555 25.7191 0.00239503 25.9843 7.50301e-05C26.2496 -0.00222497 26.5128 0.0483749 26.7584 0.148935C27.004 0.249495 27.227 0.398014 27.4146 0.585794C27.6023 0.773574 27.7507 0.996873 27.8513 1.24267C27.9516 1.48847 28.0021 1.75183 27.9999 2.01739C27.9975 2.28295 27.9424 2.54539 27.8377 2.78939C27.733 3.03339 27.5807 3.25409 27.3899 3.43857L16.813 14.0245L27.3899 24.6105C27.7539 24.9877 27.9554 25.4929 27.9508 26.0173C27.9462 26.5417 27.7362 27.0433 27.3655 27.4141C26.995 27.7849 26.4938 27.9953 25.9699 27.9999C25.4459 28.0045 24.9412 27.8029 24.5643 27.4385L13.9874 16.8525L3.41063 27.4385C3.03376 27.8029 2.529 28.0045 2.00505 27.9999C1.4811 27.9953 0.979914 27.7849 0.609414 27.4141C0.238914 27.0433 0.0287557 26.5417 0.0242196 26.0173C0.0196635 25.4929 0.221069 24.9877 0.585074 24.6105L11.1619 14.0245L0.585074 3.43857C0.210458 3.06353 0 2.55491 0 2.02457C0 1.49425 0.210458 0.985634 0.585074 0.610594Z",
    fill: "url(#paint0_linear_10631_2369)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10631_2369",
    x1: 14,
    y1: 0,
    x2: 14,
    y2: 28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7705",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60000",
    stopOpacity: 0.81
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeclineIcon);
export default __webpack_public_path__ + "static/media/declineIcon.73d91523c557cb111aca7075fb3a81ea.svg";
export { ForwardRef as ReactComponent };